<template>
    <div class="topbar-container">
        <div class="gorate-logo-container">
            <img :src="require('@/assets/logos/gorate-logo.svg')" alt="GoRate" />
        </div>
        <div class="customer-logo-container">
            <!-- <img :src="require('@/assets/logos/guimaraes-logo.png')" alt="CM Guimaraes" /> -->
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PreviewAppTopBar'
})
</script>

<style lang="scss" scoped>
.topbar-container {
    height: 8%;

    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;

    padding: 0 5%;

    .gorate-logo-container {
        grid-column: 1;
        width: 100%;
        height: 100%;

        display: grid;
        align-items: center;
        justify-items: start;

        img {
            max-width: 20%;
        }
    }

    .customer-logo-container {
        grid-column: 2;
        width: 100%;
        height: 100%;

        display: grid;
        align-items: center;
        justify-items: end;

        img {
            max-width: 20%;
        }
    }
}

@media (max-width: 600px) {
    img {
        min-width: 40%;
    }
}
</style>
